module.exports = __webpack_public_path__ + "static/media/yijing.818535db.jpg";